import type { PortfolioVersionV2 } from '@festina/unitlink-general-types/unitlink'
import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

import type { VersionContext } from './VersionProvider'

const [
  usePortfolioVersionContext,
  useOptionalPortfolioVersionContext,
  provider,
] =
  createRequiredAndOptionalContext<VersionContext<PortfolioVersionV2>>(
    'PortfolioVersion',
  )

export {
  provider,
  useOptionalPortfolioVersionContext,
  usePortfolioVersionContext,
}
